import { render, staticRenderFns } from "./TransferTab1Filter.vue?vue&type=template&id=b86cd1b2"
import script from "./TransferTab1Filter.vue?vue&type=script&lang=js"
export * from "./TransferTab1Filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports